import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchBlogData = createAsyncThunk("blogs/fetchData", async ({ id }, { rejectWithValue }) => {
    try {
        const response = await api.get("/blogs/" + id);
        console.log("aid ", response)
        const data = response.data.data;
        return data;
    } catch (error) {
        return error;
    }
});

export const blogSlice = createSlice({
    name: "aid",
    initialState: {
        loading: false,
        error: null,
        blogs: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBlogData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBlogData.fulfilled, (state, action) => {
                state.loading = false;
                state.blogs = action.payload;
            })
            .addCase(fetchBlogData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },

})


export default blogSlice.reducer